// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '../../../redux/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '../../../interfaces/interfaces';
import { UpdateTaskData } from '../interfaces/interfaces';

// interfaces.
interface UpdateTaskStatusResponse {
  message: string;
  success: boolean;
}

export const updateApproverTask = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    updateApproverTask: builder.mutation({
      query: (taskUpdateData: UpdateTaskData) => ({
        body: taskUpdateData,
        method: 'PATCH',
        url: '/update_orchestrator_task_status',
      }),
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'updateApproverTask',
        };
        return modelError;
      },
      transformResponse: (response: UpdateTaskStatusResponse) => {
        return response;
      },
      invalidatesTags: ['ApproverTasks'],
    }),
  }),
});

export const { useUpdateApproverTaskMutation } = updateApproverTask;
